import { SparklesIcon } from "@heroicons/react/24/solid";
import { classNames } from "../styles/classNames";
import PersonAvatar from "./PersonAvatar";

interface AgentAvatarProps {
  /** The person whose agent it is, shown as a small badge; `null` for none. */
  owner: { readonly userId: string; readonly name: string } | null;
  className?: string;
}

/**
 * An agent's avatar beside its answer (F70: who answered is shown): the agent's mark, and,
 * where it is another person's agent, that person's avatar as a badge. Decorative: the name
 * always stands beside it.
 */
export default function AgentAvatar({ owner, className }: AgentAvatarProps) {
  return (
    <span aria-hidden="true" className={classNames("relative inline-flex shrink-0", className)}>
      <span className="app-avatar app-avatar-md app-avatar-agent">
        <SparklesIcon className="h-4 w-4" />
      </span>
      {owner === null ? null : <PersonAvatar userId={owner.userId} name={owner.name} size="xs" className="app-avatar-badge" />}
    </span>
  );
}
